import { baseStyles, formStyles } from '@/styles';
import { t } from 'i18next';
import { LitElement, css, html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import debounce from 'lodash-es/debounce';

import { BREAKPOINT_SMALL_PX } from '@/settings';

import '@/components/fg-checkbox';

@customElement('fg-debtor-list-filters')
export class FgDebtorListFilters extends LitElement {
  @property({ type: Object })
  filterParams: { searchString: string | undefined; createdByMe: boolean } = {
    searchString: undefined,
    createdByMe: false,
  };

  @property({ type: String })
  searchInputPlaceholder = '';

  @state()
  checkboxChecked = false;

  handleCheckboxChange() {
    this.checkboxChecked = this.checkboxChecked ? false : true;

    this.filterParams = {
      searchString: this.filterParams.searchString,
      createdByMe: this.checkboxChecked,
    };

    this.dispatchEvent(
      new CustomEvent<typeof this.filterParams>('filter', {
        detail: this.filterParams,
        composed: true,
      }),
    );
  }

  handleSearchChange = debounce((value: string) => {
    this.filterParams = {
      searchString: value,
      createdByMe: this.filterParams.createdByMe,
    };
    this.dispatchEvent(
      new CustomEvent<typeof this.filterParams>('filter', {
        detail: this.filterParams,
        composed: true,
      }),
    );
  }, 500);

  render() {
    return html`
      <div class="fg-debtor-list-filters">
        <fieldset class="field">
          <label for="name-search">${t('labels.search')}</label>
          <input
            @input=${(event: { target: HTMLInputElement }) =>
              this.handleSearchChange(event.target.value)}
            type="text"
            value=${ifDefined(this.filterParams.searchString)}
            placeholder=${ifDefined(
              t(this.searchInputPlaceholder) || undefined,
            )}
            id="name-search"
            name="search-by-name"
          />
        </fieldset>
        <fieldset class="checkbox">
          <div>
            <label @click=${this.handleCheckboxChange}>
              ${t('labels.createdByMe')}
            </label>
            <fg-checkbox
              @click=${this.handleCheckboxChange}
              part="wholesale"
              ?checked=${this.checkboxChecked}
            ></fg-checkbox>
          </div>
        </fieldset>
      </div>
    `;
  }
  static styles = [
    baseStyles,
    formStyles,
    css`
      .fg-debtor-list-filters {
        display: grid;
        gap: 8px;
        padding-block-end: 16px;

        @media screen and (min-width: ${BREAKPOINT_SMALL_PX}px) {
          grid-template-columns: 1fr auto;
          gap: 16px;
        }
      }

      fieldset {
        border: none;
        padding: 0;
        display: grid;
        grid-template-rows: auto auto;
      }

      .field input {
        width: 100%;
      }

      .checkbox div {
        display: flex;
        flex-direction: row-reverse;
        gap: 8px;

        @media screen and (min-width: ${BREAKPOINT_SMALL_PX}px) {
          grid-row: 2 / 3;
          cursor: pointer;
          align-items: center;
          justify-content: center;
        }

        & fg-checkbox {
          color: var(--fg-gray--300);
          display: block;
          height: 20px;
          width: 20px;

          &&[checked] {
            color: var(--fg-success);
          }
        }
      }
    `,
  ];
}
